import { IconStatus } from '@/shared/utils'
import { TopupStatus, TopupTraderStatus } from './types'

export const TopupStatusTitles: Record<TopupStatus, string> = {
  [TopupStatus.WaitingPayment]: 'Ожидает оплаты',
  [TopupStatus.ConfirmedByPayer]: 'Подтвержден плательщиком',
  [TopupStatus.Paid]: 'Платеж выполнен',
  [TopupStatus.Cancelled]: 'Платеж отменен',
  [TopupStatus.Timeout]: 'Время ожидания истекло',
  [TopupStatus.OverPaid]: 'Переплата',
  [TopupStatus.PartiallyPaid]: 'Частичная оплата',
  [TopupStatus.Returned]: 'Платеж возвращен',
  [TopupStatus.Disput]: 'Создана апелляция',
  [TopupStatus.Unknown]: 'Неизвестный статус',
  [TopupStatus.WaitingPaymentChannel]: 'Платеж ожидает данные о платежном канале',
  [TopupStatus.RollingBack]: '',
}

export const TopupStatusIcons: Record<TopupStatus, IconStatus> = {
  [TopupStatus.WaitingPayment]: 'grey',
  [TopupStatus.ConfirmedByPayer]: 'green',
  [TopupStatus.Paid]: 'green',
  [TopupStatus.Cancelled]: 'red',
  [TopupStatus.Timeout]: 'red',
  [TopupStatus.OverPaid]: 'green',
  [TopupStatus.PartiallyPaid]: 'green',
  [TopupStatus.Returned]: 'red',
  [TopupStatus.Disput]: 'red',
  [TopupStatus.Unknown]: 'grey',
  [TopupStatus.WaitingPaymentChannel]: 'yellow',
  [TopupStatus.RollingBack]: 'grey',
}

export const STATUS_MAP: Record<number, TopupStatus | undefined> = {
  0: undefined,
  1: TopupStatus.WaitingPayment,
  2: TopupStatus.Paid,
  3: TopupStatus.Cancelled,
}

export const TRADER_STATUS_MAP: Record<number, TopupTraderStatus | undefined> = {
  0: undefined,
  1: TopupTraderStatus.All,
  2: TopupTraderStatus.WaitingPayment,
  3: TopupTraderStatus.Paid,
  4: TopupTraderStatus.Cancelled,
  5: TopupTraderStatus.Disput,
}
